
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data() {
    return {
      list: [],
      lng: lng
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      const self = this,
            $ = this.$,
            app = this.$app;
      myApp.server.get('imc/chat').then(succ => {
        console.log(succ);
        self.$setState({
          list: succ
        }, () => {
          const searchbar = app.searchbar.create({
            el: '.searchbar-chatlist',
            searchIn: '.item-title',
            searchContainer: '.search-list'
          });
        });
      }).catch(err => {
        console.log(err);
      });
    }

  },
  id: '77ccf5b5a8',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="title">Chat</div>\n        <div class="right">\n          <!-- Link to enable searchbar -->\n          <a class="link icon-only searchbar-enable" data-searchbar=".searchbar">\n            <i class="icon f7-icons if-not-md">search</i>\n            <i class="icon material-icons md-only">search</i>\n          </a>\n        </div>\n        <!-- Searchbar is a direct child of "navbar-inner" -->\n        <form class="searchbar searchbar-expandable">\n          <div class="searchbar-inner">\n            <div class="searchbar-input-wrap">\n              <input type="search" id="chatlist-search" placeholder="Search"/>\n              <i class="searchbar-icon"></i>\n              <span class="input-clear-button"></span>\n            </div>\n            <span class="searchbar-disable-button">\n              <i class="icon f7-icons">clear</i>\n            </span>\n          </div>\n        </form>\n      </div>\n    </div>\n    <!-- Scrollable page content -->\n    <div class="page-content">\n\n      <div class="searchbar-backdrop"></div>\n      <form class="searchbar searchbar-chatlist">\n        <div class="searchbar-inner">\n          <div class="searchbar-input-wrap">\n            <input type="search" style="border-radius: 10px" placeholder="Search">\n            <i class="searchbar-icon"></i>\n            <span class="input-clear-button"></span>\n          </div>\n          <span class="searchbar-disable-button"><i class="icon f7-icons">clear</i></span>\n        </div>\n      </form>\n\n      <div class="list search-list searchbar-found mt-0">\n        <ul>\n          ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.list, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <li>\n            <a href="/chat/';
          r += c(ctx_2.id, ctx_2);
          r += '/" class="item-link item-content">\n              <div class="item-media">\n                <div class="message-avatar-title" style="background-image:url(';
          r += c(ctx_2.avatar, ctx_2);
          r += ');"></div>\n              </div>\n              <div class="item-inner">\n                <div class="item-title">';
          r += c(ctx_2.caption, ctx_2);
          r += '</div>\n                <div class="item-after">\n                  ';
          r += c(ctx_2.city, ctx_2);
          r += '\n                </div>\n              </div>\n            </a>\n          </li>\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </ul>\n      </div>\n      ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.list[0], {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n      <div class="container text-align-center">\n        <img class="responsive" src="static/notfound.svg"/>\n      </div>\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n    </div>\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    